<template>
  <div class="newsinfo-module">
    <div class="news-banner">
      <img :src="commonbg" width="100%" alt="">
    </div>
    <div class="newsinfo-body">
      <div class="activity-part">
        <el-row :gutter="40">
          <el-col :span="17">
            <div>
              <div class="news-title">
                <h3>{{newsObj.title}}</h3>
              </div>
              <div class="news-items">
                <el-form :inline="true">
                  <el-form-item>
                    <div class="textUtil" v-if="newsObj.isCopy==1"><span class="is-original">原创作品</span></div>
                    <div class="textUtil" v-if="newsObj.isCopy==2">网络转载</div>
                  </el-form-item>
                  <el-form-item>
                    <div class="textUtil">分类：{{newsObj.newsTypeName}}</div>
                  </el-form-item>
                  <el-form-item>
                    <div>作者：{{newsObj.newsAuthor}}</div>
                  </el-form-item>
                  <el-form-item>
                    <div class="textUtil">
                      <img src="../../../../static/img/formIcons/clockB.png" width="20" height="20" alt="">
                      <span>{{newsObj.time}}</span>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <div class="textUtil">
                      <img @click="toggleAdmire(1)" v-if="!isAdmired" src="../../../../static/img/formIcons/admire1.png" width="18" height="18" alt="">
                      <img @click="toggleAdmire(2)" v-if="isAdmired" src="../../../../static/img/formIcons/admire2.png" width="18" height="18" alt="">
                      <span>{{newsObj.admire}}</span>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <div class="textUtil">
                      <img src="../../../../static/img/formIcons/viewed.png" width="20" height="20" alt="">
                      <span>{{newsObj.readNo}}</span>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <div v-html="newsObj.content" class="news-content"></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import * as newsApi from '@/api/frontApi/frontNews';
export default {
  data() {
    return {
      receiveMsg: null,
      activeName: 'second',
      newsObj: {
        title: '',
        subTitle: '',
        content: '',
        readNo: null,
        newsAuthor: '',
        time: '',
        admire: null,
        newsType: '',
        newsTypeName: '',
        isCopy: 1,
        newsId: ''
      },
      newsId: '',
      topTenList: [],
      isEntity: false,
      isAdmired: false
    };
  },
  computed: {
    commonbg() {
      return this.$store.state.commonbg;
    }
  },
  created() {
    this.viewActivity(this.$route.params.infoId);
  },
  beforeDestroy() {
    this.sendViewd(this.newsObj.newsId);
    this.callBackAdmire(this.newsObj.newsId);
  },
  methods: {
    viewActivity(newsID) {
      newsApi.getNewsById({ newsId: newsID }).then(res => {
        this.newsObj.title = res.data.newsTitle;
        this.newsObj.subTitle = res.data.newsSubtitle;
        this.newsObj.content = res.data.newsText;
        this.newsObj.readNo = this.viewed(res.data.newsReadNum);
        this.newsObj.newsAuthor = res.data.newsAuthor;
        this.newsObj.time = res.data.newsCreateTime;
        this.newsObj.admire = res.data.newsSupportNum;
        this.newsObj.newsType = res.data.newsType;
        this.newsObj.newsTypeName = res.data.newsTypeName;
        this.newsObj.newsId = newsID;
        // 1,原创；2,转载
        this.newsObj.isCopy = 1;
      });
    },
    getNewsRouterData() {
      if (this.$route.params.newsId) {
        this.newsId = this.$route.params.newsId;
      }
    },
    toggleAdmire(toggleType) {
      let toggleSelf = this;
      switch (toggleType) {
        case 1:
          toggleSelf.newsObj.admire++;
          toggleSelf.isAdmired = true;
          break;
        case 2:
          toggleSelf.newsObj.admire--;
          toggleSelf.isAdmired = false;
          break;
      }
    },
    viewed(viewdNo) {
      let temp = viewdNo;
      return ++temp;
    },
    showNews(newsdata) {
      // 新闻列表转具体新闻;
      // 接收子组件传回的具体新闻信息
      this.isEntity = true;
      if (newsdata) {
        this.viewActivity(newsdata.newsId);
      }
    },
    backToList() {
      this.isEntity = false;
    },
    sendViewd(currId) {
      newsApi.returnReadNo({ newsId: currId }).then(res => {});
    },
    callBackAdmire(currId) {
      // returnAdmired({ newsId: currId, userId: '' }).then(res => {});
    }
  }
};
</script>
<style lang="stylus" scoped>
.newsinfo-module {
  width: 100%;
  background-color: #fff;
  min-height: 600px;
}

.news-banner {
  width: 100%;
}

.newsinfo-body {
  width: 70%;
  margin: 0 auto;

  .activity-part {
    width: 100%;
    padding: 20px 0;

    .news-title {
      text-align: center;
      width: 100%;
    }

    .news-items {
      margin-left: 3%;
    }

    .news-content {
    }
  }
}

img {
  vertical-align: middle;
}

.textUtil img {
  margin-top: -3px;
}

.is-original {
  padding: 5px 10px;
  background-color: #66b1ff;
  color: #fff;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/activity/activityInfo.vue